module.exports = __webpack_public_path__ + "img/jian1.821d6de3.png";